import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      {/* Top CTA Band */}
      <div className="footer__cta-band">
        <div className="container">
          <div className="footer__cta-content">
            <div className="footer__cta-text">
              <span className="footer__cta-label">YOCILAB Youth Summit 2026</span>
              <h3 className="footer__cta-heading">30th &amp; 31st October 2026 · Bamenda, Cameroon</h3>
              <p className="footer__cta-desc">500+ young people. Endless opportunities. Your place is here.</p>
            </div>
            <div className="footer__cta-buttons">
              <Link to="/youth-summit/register" className="footer__btn footer__btn--primary">Register Now</Link>
              <Link to="/contact" className="footer__btn footer__btn--outline">Become a Partner</Link>
            </div>
          </div>
        </div>
      </div>

      {/* Main Footer */}
      <div className="footer__main">
        <div className="container">
          <div className="footer__grid">
            {/* Brand Column */}
            <div className="footer__brand">
              <Link to="/" className="footer__logo-link">
                <img
                  src={require('../assets/img/YOCILAB-01.png')}
                  alt="YOCILAB"
                  className="footer__logo"
                />
              </Link>
              <p className="footer__tagline">
                Empowering young Africans with skills, networks, and opportunities to design solutions that create jobs and scale impact.
              </p>
              <div className="footer__social">
                <a href="https://www.facebook.com/yocilab" target="_blank" rel="noopener noreferrer" className="footer__social-link" aria-label="Facebook">
                  <svg viewBox="0 0 24 24" fill="currentColor" width="18" height="18">
                    <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
                  </svg>
                </a>
                <a href="https://www.linkedin.com/company/yocilab/" target="_blank" rel="noopener noreferrer" className="footer__social-link" aria-label="LinkedIn">
                  <svg viewBox="0 0 24 24" fill="currentColor" width="18" height="18">
                    <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 01-2.063-2.065 2.064 2.064 0 112.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
                  </svg>
                </a>
                <a href="https://www.instagram.com/yocilab/" target="_blank" rel="noopener noreferrer" className="footer__social-link" aria-label="Instagram">
                  <svg viewBox="0 0 24 24" fill="currentColor" width="18" height="18">
                    <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z"/>
                  </svg>
                </a>
                <a href="https://www.tiktok.com/@yocilab" target="_blank" rel="noopener noreferrer" className="footer__social-link" aria-label="TikTok">
                  <svg viewBox="0 0 24 24" fill="currentColor" width="18" height="18">
                    <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64c.298 0 .59.05.86.14V9.42a6.37 6.37 0 0 0-.86-.06A6.34 6.34 0 0 0 3.1 15.7a6.34 6.34 0 0 0 10.82 4.49 6.34 6.34 0 0 0 1.86-4.49V8.58a8.28 8.28 0 0 0 4.81 1.56V6.69z"/>
                  </svg>
                </a>
                <a href="https://chat.whatsapp.com/GoTOvyXjhjk0Nln2LPfsjm" target="_blank" rel="noopener noreferrer" className="footer__social-link" aria-label="Join our WhatsApp Community">
                  <svg viewBox="0 0 24 24" fill="currentColor" width="18" height="18">
                    <path d="M17.472 14.382c-.297-.149-1.758-.868-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z"/>
                    <path d="M12.001 2C6.478 2 2 6.477 2 12c0 1.876.513 3.633 1.406 5.145L2 22l4.994-1.311A9.955 9.955 0 0012.001 22C17.523 22 22 17.523 22 12S17.523 2 12.001 2zm0 18.2a8.169 8.169 0 01-4.166-1.14l-.299-.177-2.965.778.792-2.891-.194-.297A8.173 8.173 0 013.8 12c0-4.53 3.686-8.2 8.201-8.2 4.516 0 8.2 3.67 8.2 8.2 0 4.53-3.684 8.2-8.2 8.2z"/>
                  </svg>
                </a>
              </div>
            </div>

            {/* Nav Columns */}
            <div className="footer__nav-section">
              <h4 className="footer__nav-title">About</h4>
              <ul className="footer__nav-links">
                <li><Link to="/about/who-are-we">Who Are We</Link></li>
                <li><Link to="/about/why-it-matters">Why It Matters</Link></li>
                <li><Link to="/about/our-team">Our Team</Link></li>
              </ul>
            </div>

            <div className="footer__nav-section">
              <h4 className="footer__nav-title">Academy</h4>
              <ul className="footer__nav-links">
                <li><Link to="/programs/yocilab-academy">YOCILAB Academy</Link></li>
                <li><Link to="/programs/abeta">ABETA Platform</Link></li>
                <li><Link to="/programs/yocilab-hub">YOCILAB Hub</Link></li>
              </ul>
            </div>

            <div className="footer__nav-section">
              <h4 className="footer__nav-title">Youth Summit</h4>
              <ul className="footer__nav-links">
                <li><Link to="/youth-summit">Overview</Link></li>
                <li><Link to="/youth-summit/register">Summit Registration</Link></li>
                <li><Link to="/youth-summit/campus-tour">Campus Tour</Link></li>
                <li><Link to="/youth-summit/summit-experience">Summit Experience</Link></li>
                <li><Link to="/youth-summit/innovation-challenge">Innovation Challenge</Link></li>
                <li><Link to="/youth-summit/fellowship">Fellowship</Link></li>
              </ul>
            </div>

            <div className="footer__nav-section">
              <h4 className="footer__nav-title">Connect</h4>
              <ul className="footer__nav-links">
                <li><Link to="/contact">Contact Us</Link></li>
                <li><Link to="/signature-events">Events</Link></li>
                <li><Link to="/seed4impact">Seed4Impact</Link></li>
                <li><Link to="/impact-stories">Impact Stories</Link></li>
              </ul>
            </div>
          </div>

          {/* Newsletter */}
          <div className="footer__newsletter">
            <div className="footer__newsletter-text">
              <h4 className="footer__newsletter-title">Stay in the loop</h4>
              <p className="footer__newsletter-desc">Latest news on programs, events, and opportunities for young Africans.</p>
            </div>
            <form className="footer__newsletter-form" onSubmit={(e) => e.preventDefault()}>
              <input
                type="email"
                placeholder="Enter your email address"
                className="footer__newsletter-input"
                aria-label="Email address for newsletter"
              />
              <button type="submit" className="footer__newsletter-btn">
                Subscribe
              </button>
            </form>
          </div>
        </div>
      </div>

      {/* Footer Bottom */}
      <div className="footer__bottom">
        <div className="container">
          <div className="footer__bottom-inner">
            <p className="footer__copyright">
              © {currentYear} YOCILAB (Youth Connect Innovation Lab). All rights reserved.
            </p>
            <div className="footer__legal">
              <a href="#privacy">Privacy Policy</a>
              <a href="#terms">Terms of Service</a>
              <a href="#cookies">Cookie Policy</a>
            </div>
            <div className="footer__locations">
              <span className="footer__location">
                <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/>
                  <circle cx="12" cy="10" r="3"/>
                </svg>
                Yaoundé
              </span>
              <span className="footer__location-sep">·</span>
              <span className="footer__location">Bamenda, Cameroon</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
